import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'Home',
//       component: import('../views/home'),
//     },
//     {
//       path: '/download',
//       name: 'download',
//       component: () =>
//       import('../components/home/download'),
//     }
//   ]
// })

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home'),
  },
  {
    path: '/download',
    name: 'download',
    component: () =>
    import('../components/home/download'),
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js